<div class="color-background" :style="style"></div>